export const LOCAL_STORAGE_KEYS = {
  APP_CONFIG: 'APP_CONFIG',
  CURRENT_USER: 'CURRENT_USER',
  BROWSER_LANGUAGE: 'BROWSER_LANGUAGE',
  USER_LANGUAGE: 'USER_LANGUAGE',
};
